//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "ClientTimeLine",

    data() {
        return {
            currenyear: new Date().getFullYear(),
            caseInfo: {
                caseNo: "CAS-2026-0012",
                client: "ABC Trading Sdn. Bhd.",
                caseType: "Company Registration",
                status: "In Progress",
                lastUpdated: "14 May 2026, 10:30 AM",
            },

            latestUpdate: {
                message:
                    "We have reviewed the submitted documents and are currently preparing the draft for internal review.",
                date: "14 May 2026, 10:30 AM",
            },

            timelineData: [
                {
                    status: "In Progress",
                    date: "15/05/2026 09:30 AM",
                    desc: "Work on this request has started and is currently being processed by the assigned team.",
                    fullname: "John Doe"
                },
                {
                    status: "Waiting for Client",
                    date: "14/05/2026 03:45 PM",
                    desc: "Additional information or confirmation",
                    fullname: "test "
                },
                {
                    status: "Waiting for Third Party",
                    date: "14/05/2026 11:20 AM",
                    desc: "The process is currently pending a response or action from an external third party.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    fullname: "John Doe"
                },

            ]
        };
    },

    async mounted() {
        await this.$hideLoader();
    },
};
